(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["das-van-stock-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var cards = Array.from(root.querySelectorAll('[data-recommendation]'));
    var results = root.querySelector('[data-results]');
    var status = root.querySelector('[data-status]');
    var matchCount = root.querySelector('[data-match-count]');
    var buildButton = root.querySelector('[data-build]');
    var backToTopButton = root.querySelector('[data-van-back-to-top]');
    var addButton = root.querySelector('[data-add-selected]');
    var selectedCount = root.querySelector('[data-selected-count]');
    var monthlyTotal = root.querySelector('[data-monthly-total]');
    var standardTotal = root.querySelector('[data-standard-total]');
    var savingTotal = root.querySelector('[data-saving]');
    var annualSaving = root.querySelector('[data-annual-saving]');
    var currency = root.dataset.currency || 'GBP';
    var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: currency
    });

    var faqItems = Array.from(root.querySelectorAll('[data-van-faq-item]'));

    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;

        faqItems.forEach(function (otherItem) {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });

    function selectedValue(prefix) {
      var input = root.querySelector('input[name^="' + prefix + '"]:checked');
      return input ? input.value : '';
    }

    function updateBuildButtonVisibility() {
      var discipline = selectedValue('das-discipline-');
      var usage = selectedValue('das-usage-');
      buildButton.hidden = !(discipline && usage);
    }

    root.querySelectorAll(
      'input[name^="das-discipline-"], input[name^="das-usage-"]'
    ).forEach(function (input) {
      input.addEventListener('change', updateBuildButtonVisibility);
    });

    updateBuildButtonVisibility();

    function quantityFor(card, usage) {
      var key = usage === 'light' ? 'qtyLight' : usage === 'heavy' ? 'qtyHeavy' : 'qtyRegular';
      return Math.max(1, parseInt(card.dataset[key] || '1', 10));
    }

    function matches(card, discipline) {
      var cardDiscipline = card.dataset.discipline;
      return cardDiscipline === 'both' || cardDiscipline === discipline;
    }

    cards.forEach(function (card, index) {
      card.dataset.originalOrder = String(index);
    });

    function sortCards() {
      var grid = root.querySelector('[data-product-grid]');
      var sorted = cards.slice().sort(function (a, b) {
        var aSelected = !a.hidden && a.querySelector('[data-include]').checked ? 0 : 1;
        var bSelected = !b.hidden && b.querySelector('[data-include]').checked ? 0 : 1;

        if (aSelected !== bSelected) return aSelected - bSelected;

        var aVisible = a.hidden ? 1 : 0;
        var bVisible = b.hidden ? 1 : 0;

        if (aVisible !== bVisible) return aVisible - bVisible;

        return parseInt(a.dataset.originalOrder || '0', 10) - parseInt(b.dataset.originalOrder || '0', 10);
      });

      sorted.forEach(function (card) {
        grid.appendChild(card);
      });
    }

    function updateSummary() {
      var chosen = cards.filter(function (card) {
        return !card.hidden && card.querySelector('[data-include]').checked;
      });
      var total = 0;
      var compare = 0;

      chosen.forEach(function (card) {
        var qty = Math.max(1, parseInt(card.querySelector('[data-quantity]').value || '1', 10));
        total += parseInt(card.dataset.price || '0', 10) * qty;
        compare += parseInt(card.dataset.comparePrice || card.dataset.price || '0', 10) * qty;
      });

      cards.forEach(function (card) {
        card.classList.toggle('is-selected', !card.hidden && card.querySelector('[data-include]').checked);
      });

      sortCards();

      var saving = Math.max(0, compare - total);

      selectedCount.textContent = chosen.length + ' ' + root.dataset.itemsLabel;
      monthlyTotal.textContent = formatter.format(total / 100);
      standardTotal.textContent = formatter.format(compare / 100);
      savingTotal.textContent = formatter.format(saving / 100);
      annualSaving.textContent = formatter.format((saving * 12) / 100);
    }

    function buildRecommendations() {
      var discipline = selectedValue('das-discipline-');
      var usage = selectedValue('das-usage-') || 'regular';
      status.textContent = '';

      if (!discipline) {
        status.textContent = root.dataset.missingAnswers;
        return;
      }

      var visible = 0;

      cards.forEach(function (card) {
        var show = matches(card, discipline);
        card.hidden = !show;

        if (show) {
          visible += 1;
          var perVan = quantityFor(card, usage);
          card.querySelector('[data-per-van]').textContent = perVan;
          card.querySelector('[data-quantity]').value = perVan;
          card.querySelector('[data-include]').checked = card.dataset.priority === 'essential';
        }
      });

      matchCount.textContent = visible + ' ' + root.dataset.productsSuggested;
      results.hidden = false;
      updateSummary();
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    cards.forEach(function (card) {
      var input = card.querySelector('[data-quantity]');
      var include = card.querySelector('[data-include]');
      var minus = card.querySelector('[data-minus]');
      var plus = card.querySelector('[data-plus]');

      include.addEventListener('change', updateSummary);

      input.addEventListener('change', function () {
        var value = Math.min(99, Math.max(1, parseInt(input.value || '1', 10)));
        input.value = value;
        updateSummary();
      });

      minus.addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
        updateSummary();
      });

      plus.addEventListener('click', function () {
        input.value = Math.min(99, parseInt(input.value || '1', 10) + 1);
        updateSummary();
      });
    });

    buildButton.addEventListener('click', buildRecommendations);

    function updateBackToTopVisibility() {
      if (!backToTopButton) return;
      backToTopButton.hidden = window.scrollY < 220;
    }

    if (backToTopButton) {
      backToTopButton.addEventListener('click', function () {
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        root.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });

      window.addEventListener('scroll', updateBackToTopVisibility, { passive: true });
      updateBackToTopVisibility();
    }

    async function loadAllVanStockProducts() {
      var resultsList = document.querySelector("results-list[data-van-stock-all-products='true']");
      if (!resultsList || resultsList.dataset.vanStockReady === 'true') return;

      var resultsContainer = resultsList.querySelector('#ResultsList');
      var grid = resultsList.querySelector('#ResultsList [data-testid="product-grid"]');
      if (!resultsContainer || !grid) return;

      var lastPage = Math.max(1, parseInt(grid.dataset.lastPage || '1', 10));
      var currentPage = Math.max(
        1,
        parseInt(
          grid.querySelector('.product-grid__item[data-page]')?.dataset.page ||
          new URL(window.location.href).searchParams.get('page') ||
          '1',
          10
        )
      );

      resultsList.classList.add('das-van-all-products-loading');

      var loadingStatus = document.createElement('div');
      loadingStatus.className = 'das-van-all-products-status';
      loadingStatus.setAttribute('role', 'status');
      loadingStatus.setAttribute('aria-live', 'polite');
      loadingStatus.textContent = root.dataset.loadingAllProducts;
      resultsContainer.parentNode.insertBefore(loadingStatus, resultsContainer);

      function collectItems(sourceGrid) {
        return Array.from(sourceGrid.querySelectorAll('.product-grid__item[data-van-product-type]'));
      }

      function displayGroupType(productType) {
        var type = (productType || 'Other van stock').trim();

        if ([
          'Electric Strike',
          'Electric Strike - Fail Safe',
          'Electric Strike - Fail Secure',
          'Door Strike Accessories',
          'Electric Strike Accessories'
        ].includes(type)) {
          return 'Electric Strikes';
        }

        if (
          /maglock/i.test(type) &&
          /(accessor|bracket)/i.test(type)
        ) {
          return 'Maglock Accessories & Brackets';
        }

        if (type === 'Shearlock') {
          return 'Maglock';
        }

        if ([
          'Keypad',
          'Keypads & Readers',
          'Keypad Rain Cover'
        ].includes(type)) {
          return 'Keypads & Readers';
        }

        if ([
          'Exit Button',
          'Press For Assistance'
        ].includes(type)) {
          return 'Exit Buttons';
        }

        if (
          type === 'Relay' ||
          type === 'Voltage Reducer' ||
          /timer/i.test(type)
        ) {
          return 'Relays, Timers & Voltage Reducers';
        }

        if ([
          'Wireless Receiver',
          'Wireless Receivers',
          'Wireless Transmitter & Receiver Kits',
          'Wireless Transmitter',
          'Wireless Transmitters'
        ].includes(type)) {
          return 'Wireless Transmitter & Receivers';
        }

        if (/^PSU\s/i.test(type)) {
          return 'PSUs';
        }

        return type;
      }

      function groupFilterConfig(groupName) {
        if (groupName === 'Maglock Accessories & Brackets') {
          return {
            allLabel: root.dataset.maglockAccessoriesAll,
            ariaLabel: root.dataset.maglockAccessoriesFilter
          };
        }

        if (groupName === 'PSUs') {
          return {
            allLabel: root.dataset.psusAll,
            ariaLabel: root.dataset.psusFilter
          };
        }

        return null;
      }

      function buildGroupHeading(groupName, groupItems) {
        var heading = document.createElement('li');
        heading.className = 'das-van-product-group';
        heading.setAttribute('role', 'presentation');
        heading.dataset.vanDisplayGroup = groupName;

        var headingRow = document.createElement('div');
        headingRow.className = 'das-van-product-group__head';

        var headingText = document.createElement('h3');
        headingText.textContent = groupName;
        headingRow.appendChild(headingText);

        var filterConfig = groupFilterConfig(groupName);

        if (filterConfig) {
          var sourceTypes = Array.from(new Set(
            groupItems.map(function (item) {
              return (item.dataset.vanProductType || '').trim();
            }).filter(Boolean)
          )).sort(function (a, b) {
            return a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true });
          });

          if (sourceTypes.length > 1) {
            var select = document.createElement('select');
            select.className = 'das-van-product-group__select';
            select.setAttribute('aria-label', filterConfig.ariaLabel);

            var allOption = document.createElement('option');
            allOption.value = '';
            allOption.textContent = filterConfig.allLabel;
            select.appendChild(allOption);

            sourceTypes.forEach(function (sourceType) {
              var option = document.createElement('option');
              option.value = sourceType;
              option.textContent = sourceType;
              select.appendChild(option);
            });

            select.addEventListener('change', function () {
              var selectedType = select.value;

              groupItems.forEach(function (item) {
                item.hidden = selectedType !== '' &&
                  (item.dataset.vanProductType || '').trim() !== selectedType;
              });
            });

            headingRow.appendChild(select);
          }
        }

        heading.appendChild(headingRow);
        return heading;
      }

      function renderGrouped(items) {
        var unique = new Map();

        items.forEach(function (item) {
          var productId = item.dataset.productId || item.id;
          if (productId && !unique.has(productId)) {
            unique.set(productId, item);
          }
        });

        var products = Array.from(unique.values());

        function groupSortKey(groupName) {
          if (groupName === 'Maglock') return 'Maglock 00';
          if (groupName === 'External Maglock') return 'Maglock 01';
          if (groupName === 'Maglock Accessories & Brackets') return 'Maglock 02';
          return groupName;
        }

        products.sort(function (a, b) {
          var typeA = displayGroupType(a.dataset.vanProductType);
          var typeB = displayGroupType(b.dataset.vanProductType);
          var typeCompare = groupSortKey(typeA).localeCompare(
            groupSortKey(typeB),
            undefined,
            { sensitivity: 'base' }
          );

          if (typeCompare !== 0) return typeCompare;

          function modelNumber(item, groupName) {
            var sourceType = (item.dataset.vanProductType || '').trim();
            var sku = (item.dataset.vanProductSku || '').trim();
            var title = (item.querySelector('.product-card__link')?.getAttribute('aria-label') || '').trim();
            var combined = [sourceType, sku, title].join(' ');

            if (groupName === 'PSUs') {
              var ampMatch = sourceType.match(/PSU\s*(\d+(?:\.\d+)?)A?/i);
              return ampMatch ? parseFloat(ampMatch[1]) : Number.MAX_SAFE_INTEGER;
            }

            if (
              groupName === 'Maglock' ||
              groupName === 'External Maglock' ||
              groupName === 'Maglock Accessories & Brackets'
            ) {
              var maglockMatch = combined.match(/(?:SML|EXML|ML|IP)\s*[-_]?\s*(\d{3,4})/i);
              if (!maglockMatch) {
                maglockMatch = combined.match(/\b(300|600|1200|3000)\b/i);
              }
              return maglockMatch ? parseInt(maglockMatch[1], 10) : Number.MAX_SAFE_INTEGER;
            }

            return Number.MAX_SAFE_INTEGER;
          }

          var modelA = modelNumber(a, typeA);
          var modelB = modelNumber(b, typeB);
          if (modelA !== modelB) return modelA - modelB;

          var skuA = (a.dataset.vanProductSku || '').trim();
          var skuB = (b.dataset.vanProductSku || '').trim();
          var skuCompare = skuA.localeCompare(
            skuB,
            undefined,
            { sensitivity: 'base', numeric: true }
          );

          if (skuCompare !== 0) return skuCompare;

          var titleA = (a.querySelector('.product-card__link')?.getAttribute('aria-label') || '').trim();
          var titleB = (b.querySelector('.product-card__link')?.getAttribute('aria-label') || '').trim();
          return titleA.localeCompare(
            titleB,
            undefined,
            { sensitivity: 'base', numeric: true }
          );
        });

        var groups = new Map();

        products.forEach(function (item) {
          var groupName = displayGroupType(item.dataset.vanProductType);

          if (!groups.has(groupName)) {
            groups.set(groupName, []);
          }

          groups.get(groupName).push(item);
        });

        grid.innerHTML = '';

        groups.forEach(function (groupItems, groupName) {
          grid.appendChild(buildGroupHeading(groupName, groupItems));

          groupItems.forEach(function (item) {
            item.dataset.vanDisplayGroup = groupName;
            item.hidden = false;
            grid.appendChild(item);
          });
        });

        buildSectionNavigation(Array.from(groups.keys()));
        grid.dataset.lastPage = '1';
      }

      var initialItems = collectItems(grid);

      try {
        if (lastPage > 1) {
          var sectionId = resultsList.getAttribute('section-id');
          var pages = [];

          for (var page = 1; page <= lastPage; page += 1) {
            if (page !== currentPage) pages.push(page);
          }

          var pageItems = await Promise.all(
            pages.map(async function (page) {
              var url = new URL(window.location.href);
              url.searchParams.set('page', String(page));
              url.searchParams.set('section_id', sectionId);
              url.hash = '';

              var response = await fetch(url.toString(), {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
              });

              if (!response.ok) throw new Error('Van Stock page load failed');

              var html = await response.text();
              var documentPage = new DOMParser().parseFromString(html, 'text/html');
              var pageGrid = documentPage.querySelector('#ResultsList [data-testid="product-grid"]');

              if (!pageGrid) throw new Error('Van Stock product grid missing');

              return collectItems(pageGrid).map(function (item) {
                return document.importNode(item, true);
              });
            })
          );

          renderGrouped(initialItems.concat(pageItems.flat()));
        } else {
          renderGrouped(initialItems);
        }

        resultsList.dataset.vanStockReady = 'true';
      } catch (error) {
        renderGrouped(initialItems);
      } finally {
        loadingStatus.remove();
        resultsList.classList.remove('das-van-all-products-loading');
      }
    }

    function scheduleVanStockProductLoad() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loadAllVanStockProducts, { once: true });
      } else {
        loadAllVanStockProducts();
      }
    }

    scheduleVanStockProductLoad();

    var sectionNav = root.querySelector('[data-van-section-nav]');
    var activeSectionGroup = '';

    function resetGroupDropdowns() {
      document.querySelectorAll('#ResultsList .das-van-product-group__select').forEach(function (select) {
        select.value = '';
      });
    }

    function showVanStockSection(groupName, shouldScroll) {
      var grid = document.querySelector('#ResultsList [data-testid="product-grid"]');
      if (!grid) return;

      activeSectionGroup = groupName || '';
      resetGroupDropdowns();

      grid.querySelectorAll('.das-van-product-group').forEach(function (heading) {
        var matches = !activeSectionGroup || heading.dataset.vanDisplayGroup === activeSectionGroup;
        heading.hidden = !matches;
      });

      grid.querySelectorAll('.product-grid__item[data-van-display-group]').forEach(function (item) {
        var matches = !activeSectionGroup || item.dataset.vanDisplayGroup === activeSectionGroup;
        item.hidden = !matches;
      });

      if (sectionNav) {
        sectionNav.querySelectorAll('[data-van-section-button]').forEach(function (button) {
          var active = (button.dataset.group || '') === activeSectionGroup;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      if (shouldScroll) {
        document.getElementById('ResultsList')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function buildSectionNavigation(groupNames) {
      if (!sectionNav) return;

      var allButton = sectionNav.querySelector('[data-van-section-button][data-group=""]');
      sectionNav.innerHTML = '';

      if (allButton) {
        sectionNav.appendChild(allButton);
      }

      groupNames.forEach(function (groupName) {
        var button = document.createElement('button');
        button.type = 'button';
        button.dataset.vanSectionButton = '';
        button.dataset.group = groupName;
        button.setAttribute('aria-pressed', 'false');
        button.textContent = groupName;
        button.addEventListener('click', function () {
          showVanStockSection(groupName, true);
        });
        sectionNav.appendChild(button);
      });

      if (allButton) {
        allButton.onclick = function () {
          showVanStockSection('', true);
        };
      }

      showVanStockSection(activeSectionGroup, false);
    }

    addButton.addEventListener('click', async function () {
      var chosen = cards.filter(function (card) {
        return !card.hidden && card.querySelector('[data-include]').checked;
      });

      if (!chosen.length) {
        status.textContent = root.dataset.noSelection;
        return;
      }

      var items = chosen.map(function (card) {
        return {
          merchandiseId: String(card.dataset.variantId),
          quantity: Math.max(1, parseInt(card.querySelector('[data-quantity]').value || '1', 10)),
          sellingPlanId: String(card.dataset.sellingPlanId)
        };
      });

      var originalText = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = root.dataset.adding;
      status.textContent = '';

      try {
        var updateCart = window.Shopify && window.Shopify.actions && window.Shopify.actions.updateCart;
        if (typeof updateCart !== 'function') {
          throw new Error('Cart update is unavailable');
        }

        var result = await updateCart(
          { lines: items },
          { event: { context: 'product' } }
        );

        var userErrors = result && Array.isArray(result.userErrors) ? result.userErrors : [];
        if (userErrors.length) {
          throw new Error(userErrors.map(function (item) { return item.message; }).join(' '));
        }

        addButton.textContent = root.dataset.added;
        status.textContent = root.dataset.added + '. ';

        var link = document.createElement('a');
        link.href = root.dataset.cartUrl;
        link.textContent = root.dataset.viewCart;
        status.appendChild(link);

        window.setTimeout(function () {
          addButton.disabled = false;
          addButton.textContent = originalText;
        }, 1800);
      } catch (error) {
        addButton.disabled = false;
        addButton.textContent = originalText;
        status.textContent = root.dataset.error;
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-das-van-stock]').forEach(init);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-my-jobs"] && !Shopify.designMode) return;
  try {
    
  const initializeSavedJobsPage = (scope = document) => {
    const request = async (url, options = {}) => {
      const response = await fetch(url, { credentials: 'same-origin', ...options });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data?.error?.message || 'The request could not be completed.');
      return data;
    };
    const productDetailsCache = new Map();
    const datasheetCache = new Map();
    const pendingProductSaves = new Map();
    const formatMoney = (root, amount) => new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency || 'GBP' }).format(amount);
    const quoteSentAge = (job) => {
      if (job.quote?.status !== 'sent' || !job.quote.sentAt) return '';
      const sentAt = Date.parse(job.quote.sentAt);
      if (!Number.isFinite(sentAt)) return '';
      const elapsed = Math.max(0, Date.now() - sentAt);
      const minute = 60 * 1000;
      const hour = 60 * minute;
      const day = 24 * hour;
      if (elapsed < hour) {
        const minutes = Math.max(1, Math.floor(elapsed / minute));
        return minutes + ' minute' + (minutes === 1 ? '' : 's') + ' ago';
      }
      if (elapsed < day) {
        const hours = Math.floor(elapsed / hour);
        return hours + ' hour' + (hours === 1 ? '' : 's') + ' ago';
      }
      const days = Math.floor(elapsed / day);
      return days + ' day' + (days === 1 ? '' : 's') + ' ago';
    };
    const quoteMeta = (root, job) => {
      const age = quoteSentAge(job);
      if (!age) return null;
      const recipient = root.dataset.customerEmail || 'your account email';
      return text('small', (job.quote.draftOrderName || 'Quote') + ' sent ' + age + ' to ' + recipient, 'my-jobs-page__quote-meta');
    };
    const getProductDetails = (savedProduct) => {
      const key = String(savedProduct.productUrl || '') + '::' + String(savedProduct.variantId || '');
      if (productDetailsCache.has(key)) return productDetailsCache.get(key);
      const promise = (async () => {
        try {
          if (!savedProduct.productUrl) throw new Error('No product URL');
          const pathname = new URL(savedProduct.productUrl, window.location.origin).pathname;
          const handle = pathname.split('/').filter(Boolean).pop();
          const routeRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(routeRoot + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Product details unavailable');
          const product = await response.json();
          const variantId = String(savedProduct.variantId || '').split('/').pop();
          const variant = (product.variants || []).find((entry) => String(entry.id) === variantId);
          const photo = variant?.featured_image || product.featured_image || product.images?.[0] || '';
          return {
            title: product.title || savedProduct.title || 'Saved product',
            variantTitle: variant?.public_title || (variant?.title !== 'Default Title' ? variant?.title : '') || savedProduct.variantTitle || '',
            type: product.type || savedProduct.projectGroup || 'Other items',
            sku: variant?.sku || savedProduct.sku || 'Not listed',
            image: typeof photo === 'string' ? photo : (photo?.src || photo?.url || ''),
            unitPrice: variant && Number.isFinite(Number(variant.price)) ? Number(variant.price) / 100 : null
          };
        } catch (error) {
          return { title: savedProduct.title || 'Saved product', type: savedProduct.projectGroup || 'Other items', sku: savedProduct.sku || 'Not listed', image: savedProduct.image || '', unitPrice: Number.isFinite(Number(savedProduct.unitPrice)) ? Number(savedProduct.unitPrice) : null };
        }
      })();
      productDetailsCache.set(key, promise);
      return promise;
    };
    const getDatasheet = (item) => {
      const key = item.productUrl || '';
      if (!key) return Promise.resolve('');
      if (datasheetCache.has(key)) return datasheetCache.get(key);
      const promise = (async () => {
        try {
          const url = new URL(key, window.location.origin);
          if (url.origin !== window.location.origin) return '';
          url.search = '';
          url.searchParams.set('section_id', 'das-project-product-data');
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Datasheet unavailable');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const raw = parsed.querySelector('[data-das-datasheet-url]')?.dataset.dasDatasheetUrl;
          if (!raw) return '';
          const link = new URL(raw, window.location.origin);
          return ['https:', 'http:'].includes(link.protocol) ? link.href : '';
        } catch { datasheetCache.delete(key); return ''; }
      })();
      datasheetCache.set(key, promise);
      return promise;
    };
    const getPlanLine = async (item) => {
      const [detail, datasheet] = await Promise.all([getProductDetails(item), getDatasheet(item)]);
      return { item, detail: { ...detail, datasheet } };
    };
    const postcodeLocation = async (postcode) => {
      const response = await fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(postcode), { headers: { Accept: 'application/json' } });
      const data = await response.json().catch(() => ({}));
      const location = data?.result;
      if (!response.ok || !location || !Number.isFinite(Number(location.latitude)) || !Number.isFinite(Number(location.longitude))) {
        throw new Error('We could not find that UK postcode. Check it and try again.');
      }
      return { latitude: Math.round(Number(location.latitude) * 100) / 100, longitude: Math.round(Number(location.longitude) * 100) / 100 };
    };
    const ensureMapLocation = async (root, job) => {
      if (!job.sitePostcode) throw new Error('Add a site postcode in Plan Project Details before moving this project to ordered.');
      if (job.mapLocation) return job;
      const mapLocation = await postcodeLocation(job.sitePostcode);
      const result = await request(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ mapLocation })
      });
      return result.job;
    };
    const flushDoorNotes = async (root, jobId) => {
      for (const editor of root._projectNoteEditors || []) {
        if (String(editor.jobId) === String(jobId)) await editor.save();
      }
      await pendingProductSaves.get(String(jobId));
    };
    const doorNotesEditor = (root, job, door) => {
      const wrap = document.createElement('div');
      wrap.className = 'my-jobs-page__door-notes';
      const label = text('label', 'Notes for ' + door.name);
      const textarea = document.createElement('textarea');
      textarea.id = 'door-notes-' + job.id + '-' + door.id;
      textarea.rows = 4;
      textarea.maxLength = 2000;
      textarea.value = door.note || '';
      textarea.placeholder = 'Installation instructions, cable routes or other notes for this asset';
      label.htmlFor = textarea.id;
      const controls = document.createElement('div');
      controls.className = 'my-jobs-page__notes-controls';
      const saveButton = document.createElement('button');
      saveButton.type = 'button';
      saveButton.className = 'my-jobs-page__button';
      saveButton.textContent = 'Save notes';
      const status = text('span', 'Notes appear on the engineers sheet.');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      let lastQueued = textarea.value.trim();
      let pending = Promise.resolve();
      let timer;
      const save = () => {
        clearTimeout(timer);
        const value = textarea.value.trim();
        if (value === lastQueued) return pending;
        lastQueued = value;
        status.textContent = 'Saving notes…';
        const previous = pendingProductSaves.get(String(job.id)) || Promise.resolve();
        pending = previous.catch(() => {}).then(() => request(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), {
          method: 'PATCH', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ doorNote: { doorId: door.id, note: value } })
        })).then((result) => {
          const confirmed = result.job?.doors?.find((entry) => entry.id === door.id)?.note || '';
          if (confirmed !== value) throw new Error('Notes were not saved. Please try again.');
          door.note = confirmed;
          const cached = (root._savedJobs || []).find((entry) => entry.id === job.id)?.doors?.find((entry) => entry.id === door.id);
          if (cached) cached.note = confirmed;
          if (textarea.value.trim() === value) status.textContent = 'Notes saved';
        }).catch((error) => {
          lastQueued = null;
          status.textContent = error.message || 'Unable to save notes. Please try again.';
          throw error;
        });
        pendingProductSaves.set(String(job.id), pending);
        return pending;
      };
      textarea.addEventListener('input', () => {
        status.textContent = 'Unsaved notes';
        clearTimeout(timer);
        timer = setTimeout(() => save().catch(() => {}), 800);
      });
      textarea.addEventListener('blur', () => save().catch(() => {}));
      saveButton.addEventListener('click', () => save().catch(() => {}));
      root._projectNoteEditors.push({ jobId: job.id, save });
      controls.append(saveButton, status);
      wrap.append(label, textarea, controls);
      return wrap;
    };
    const saveJobProducts = (root, job, products) => {
      const previous = pendingProductSaves.get(String(job.id)) || Promise.resolve();
      const next = previous.catch(() => {}).then(() => request(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ products }) }));
      pendingProductSaves.set(String(job.id), next);
      return next;
    };
    const updateSubtotal = async (root, job, output) => {
      output.textContent = 'Subtotal ex VAT: loading…';
      const lines = await Promise.all((job.products || []).map(getProductDetails));
      if (lines.some((line) => line.unitPrice === null)) {
        output.textContent = 'Subtotal ex VAT: price unavailable';
        return;
      }
      const total = lines.reduce((sum, line, index) => sum + line.unitPrice * (Number(job.products[index].quantity) || 0), 0);
      output.textContent = 'Subtotal ex VAT: ' + formatMoney(root, total);
    };
    const deliveryProgress = (root, total) => {
      const threshold = 300;
      const wrap = document.createElement('div');
      wrap.className = 'my-jobs-page__delivery';
      wrap.setAttribute('role', 'status');
      wrap.setAttribute('aria-live', 'polite');
      const message = text('p', '', 'my-jobs-page__delivery-message');
      const track = document.createElement('div');
      track.className = 'my-jobs-page__delivery-track';
      track.setAttribute('aria-hidden', 'true');
      const bar = document.createElement('span');
      bar.className = 'my-jobs-page__delivery-bar';
      const note = text('p', 'Free delivery on orders over £300 ex VAT', 'my-jobs-page__delivery-note');
      if (total === null) {
        message.textContent = 'Delivery progress is unavailable while a product price is missing.';
      } else if (total >= threshold) {
        message.textContent = "✓ You've unlocked FREE delivery";
        bar.style.width = '100%';
      } else {
        message.textContent = formatMoney(root, threshold - total) + ' away from FREE delivery';
        bar.style.width = Math.max(0, (total / threshold) * 100) + '%';
      }
      track.append(bar);
      wrap.append(message, track, note);
      return wrap;
    };
    const printProject = async (root, jobId) => {
      await flushDoorNotes(root, jobId);
      const latest = await request(root.dataset.apiRoot + '/' + encodeURIComponent(jobId));
      const project = latest.job;
      if (!project) throw new Error('Project unavailable. Please try again.');
      const lines = await Promise.all((project.products || []).map(getPlanLine));
      if (typeof window.DASDownloadEngineersSheet !== 'function') {
        throw new Error('PDF download is not ready. Refresh the page and try again.');
      }
      await window.DASDownloadEngineersSheet({
        project: project, lines: lines, logoUrl: root.dataset.printLogo || ''
      });
    };
    const renderDetailsFooter = (root, job, total, empty = false) => {
      const footer = root.querySelector('[data-project-details-footer]');
      const totalText = text('p', 'Project total ex VAT: ' + (total === null ? 'price unavailable' : formatMoney(root, total)), 'my-jobs-page__details-total');
      const actions = document.createElement('div');
      actions.className = 'my-jobs-page__details-footer-actions';
      actions.append(totalText);
      const order = button(job.status === 'ordered' || job.status === 'completed' ? 'Reorder' : 'Add to basket', 'order', true);
      order.classList.add('my-jobs-page__details-order');
      order.dataset.jobId = job.id;
      order.disabled = empty;
      const print = button('Download engineers sheet (PDF)', 'print', job.status === 'ordered' || job.status === 'completed');
      print.classList.add('my-jobs-page__engineers-sheet-button');
      if (job.status !== 'ordered' && job.status !== 'completed') print.classList.add('my-jobs-page__engineers-sheet-button--locked');
      print.dataset.jobId = job.id;
      print.disabled = empty;
      const quote = button(job.quote?.status === 'sent' ? 'Raise revised quote' : 'Raise quote', 'quote', true);
      quote.classList.add('my-jobs-page__button--quote');
      quote.classList.add('my-jobs-page__button--order');
      quote.dataset.jobId = job.id;
      quote.disabled = empty;
      const quoteAction = document.createElement('div');
      quoteAction.className = 'my-jobs-page__quote-action';
      quoteAction.append(quote);
      const detailQuoteMeta = quoteMeta(root, job);
      if (detailQuoteMeta) quoteAction.append(detailQuoteMeta);
      actions.append(print, order, quoteAction);
      footer.replaceChildren(deliveryProgress(root, total), actions);
    };
    const doorLocationOptions = ['Main Entrance', 'Rear Entrance', 'Side Entrance', 'Lobby Entrance', 'Staff Entrance', 'Fire Exit', 'Loading Bay', 'Internal Door', 'Pedestrian Gate', 'Vehicle Gate', 'Sliding Gate', 'Swing Gate', 'Barrier', 'Other'];
    const doorLocationHeading = (root, job, doorGroup) => {
      const heading = document.createElement('h3');
      heading.className = 'my-jobs-page__door-heading';
      const select = document.createElement('select');
      select.className = 'my-jobs-page__door-location';
      select.setAttribute('aria-label', 'Asset location');
      for (const location of doorLocationOptions) {
        const option = document.createElement('option');
        option.value = location;
        option.textContent = location;
        select.append(option);
      }
      const standard = doorLocationOptions.includes(doorGroup.name) ? doorGroup.name : 'Other';
      select.value = standard;
      const other = document.createElement('input');
      other.className = 'my-jobs-page__other-location' + (standard === 'Other' ? ' is-visible' : '');
      other.type = 'text';
      other.maxLength = 120;
      other.value = standard === 'Other' ? doorGroup.name : '';
      other.placeholder = 'Enter asset location';
      other.setAttribute('aria-label', 'Other asset location');
      const status = text('span', '', 'my-jobs-page__door-save-status');
      const updateOther = () => {
        const isOther = select.value === 'Other';
        other.classList.toggle('is-visible', isOther);
        other.required = isOther;
      };
      const save = async () => {
        const name = select.value === 'Other' ? other.value.trim() : select.value;
        if (!name) { status.textContent = 'Enter the asset location.'; return; }
        if (name === doorGroup.name) return;
        status.textContent = 'Saving…';
        const doors = (job.doors || []).map((door) => door.id === doorGroup.id ? { ...door, name } : door);
        try {
          const result = await request(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ doors }) });
          const saved = result.job?.doors?.find((door) => door.id === doorGroup.id);
          if (!saved || saved.name !== name) throw new Error('Asset location was not saved.');
          job.doors = result.job.doors;
          doorGroup.name = name;
          status.textContent = 'Saved';
        } catch (error) { status.textContent = error.message || 'Unable to save location.'; }
      };
      select.addEventListener('change', () => { updateOther(); save(); });
      other.addEventListener('blur', save);
      const duplicate = button('Duplicate asset', 'duplicate-door');
      duplicate.classList.add('my-jobs-page__duplicate-door');
      duplicate.dataset.jobId = job.id;
      duplicate.dataset.doorId = doorGroup.id;
      duplicate.title = 'Copy this asset and its assigned products';
      const remove = button('Remove asset', 'remove-door');
      remove.classList.add('my-jobs-page__remove-door');
      remove.dataset.jobId = job.id;
      remove.dataset.doorId = doorGroup.id;
      remove.title = 'Remove this asset and return its products to Unassigned items';
      heading.append(select, other, duplicate, remove, status);
      return heading;
    };
    const moveProductToDoor = async (root, job, lineId, doorId) => {
      const current = (job.products || []).find((product) => String(product.lineId) === String(lineId));
      if (!current || String(current.doorId || '') === String(doorId || '')) return;
      const products = (job.products || []).map((product) => String(product.lineId) === String(lineId)
        ? { ...product, doorId: doorId || undefined }
        : product);
      const result = await request(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ products })
      });
      return result.job;
    };
    const sitePostcodeEditor = (root, job) => {
      const wrap = document.createElement('section');
      wrap.className = 'my-jobs-page__site-postcode';
      const label = document.createElement('label');
      const input = document.createElement('input');
      input.id = 'site-postcode-' + job.id;
      input.type = 'text';
      input.maxLength = 8;
      input.autocomplete = 'postal-code';
      input.value = job.sitePostcode || '';
      label.htmlFor = input.id;
      label.append('Site postcode', input);
      const save = button('Save postcode', 'save-site-postcode');
      save.dataset.jobId = job.id;
      const status = text('span', '', 'my-jobs-page__site-postcode-status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      const savePostcode = async () => {
        const sitePostcode = input.value.trim().toUpperCase().replace(/\s+/g, ' ');
        save.disabled = true;
        status.textContent = sitePostcode ? 'Checking postcode…' : 'Removing postcode…';
        try {
          const mapLocation = sitePostcode ? await postcodeLocation(sitePostcode) : null;
          const result = await request(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), {
            method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ sitePostcode, mapLocation })
          });
          Object.assign(job, result.job);
          input.value = result.job.sitePostcode || '';
          status.textContent = sitePostcode ? 'Saved' : 'Removed';
        } catch (error) { status.textContent = error.message || 'Unable to save postcode.'; }
        finally { save.disabled = false; }
      };
      save.removeAttribute('data-job-action');
      save.addEventListener('click', savePostcode);
      input.addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); savePostcode(); } });
      wrap.append(label, save, status);
      return wrap;
    };
    const openProjectDetails = async (root, job) => {
      await flushDoorNotes(root, job.id);
      root._projectNoteEditors = [];
      const dialog = root.querySelector('[data-project-details-dialog]');
      const content = dialog.querySelector('[data-project-details-content]');
      const loadingHeading = text('h2', job.name, 'my-jobs-page__details-heading');
      loadingHeading.id = 'project-details-heading';
      content.className = 'my-jobs-page__details-content';
      content.replaceChildren(loadingHeading, text('p', 'Loading project details…'));
      renderDetailsFooter(root, job, null, true);
      dialog.showModal();
      const lineDetails = await Promise.all((job.products || []).map(getPlanLine));
      content.replaceChildren();
      const heading = text('h2', job.name, 'my-jobs-page__details-heading');
      heading.id = 'project-details-heading';
      content.append(heading);
      content.append(sitePostcodeEditor(root, job));
      if (!lineDetails.length && !(job.doors || []).length) {
        content.append(text('p', root.dataset.messageEmptyProducts));
        renderDetailsFooter(root, job, 0, true);
        return;
      }
      const totalKnown = lineDetails.every(({ detail }) => detail.unitPrice !== null);
      const total = totalKnown ? lineDetails.reduce((sum, { item, detail }) => sum + detail.unitPrice * (Number(item.quantity) || 1), 0) : null;
      renderDetailsFooter(root, job, total);
      const doorGroups = new Map();
      for (const door of job.doors || []) {
        doorGroups.set(door.id, { id: door.id, name: door.name, note: door.note || '', types: new Map() });
      }
      for (const line of lineDetails) {
        const doorId = String(line.item.doorId || '');
        const savedDoor = (job.doors || []).find((door) => door.id === doorId);
        const groupId = savedDoor ? doorId : '';
        if (!doorGroups.has(groupId)) doorGroups.set(groupId, { name: 'Unassigned items', types: new Map() });
        const type = line.detail.type || 'Other items';
        const doorGroup = doorGroups.get(groupId);
        if (!doorGroup.types.has(type)) doorGroup.types.set(type, []);
        doorGroup.types.get(type).push(line);
      }
      for (const doorGroup of doorGroups.values()) {
        if (!doorGroup.types.size && !doorGroup.id) continue;
        const group = document.createElement('section');
        group.className = 'my-jobs-page__details-group';
        if (doorGroup.id) {
          group.dataset.doorId = doorGroup.id;
          group.addEventListener('dragover', (event) => {
            if (!event.dataTransfer?.types.includes('application/x-das-product')) return;
            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';
            group.classList.add('is-drop-target');
          });
          group.addEventListener('dragleave', (event) => {
            if (!group.contains(event.relatedTarget)) group.classList.remove('is-drop-target');
          });
          group.addEventListener('drop', async (event) => {
            event.preventDefault();
            group.classList.remove('is-drop-target');
            const lineId = event.dataTransfer.getData('application/x-das-product');
            if (!lineId) return;
            try {
              const updated = await moveProductToDoor(root, job, lineId, doorGroup.id);
              if (updated) { dialog.close(); await openProjectDetails(root, updated); }
            } catch (error) {
              const message = root.querySelector('[data-jobs-message]');
              message.textContent = error.message || root.dataset.messageError;
              message.hidden = false;
            }
          });
        }
        group.append(doorLocationHeading(root, job, doorGroup));
        if (doorGroup.id && doorGroup.types.size) group.append(text('p', 'Drag a product row to another asset to move it.', 'my-jobs-page__details-drop-hint'));
        for (const [type, lines] of doorGroup.types) {
          const typeGroup = document.createElement('section');
          typeGroup.className = 'my-jobs-page__details-type';
          typeGroup.append(text('h4', type));
          const tableWrap = document.createElement('div');
          tableWrap.className = 'my-jobs-page__details-table-wrap';
          const table = document.createElement('table');
          table.className = 'my-jobs-page__details-table';
          const colgroup = document.createElement('colgroup');
          for (const width of ['42%', '18%', '8%', '16%', '16%']) { const column = document.createElement('col'); column.style.width = width; colgroup.append(column); }
          const thead = document.createElement('thead');
          const headerRow = document.createElement('tr');
          for (const label of ['Product', 'SKU', 'Qty', 'Unit price ex VAT', 'Subtotal ex VAT']) { const headingCell = text('th', label); headingCell.scope = 'col'; headerRow.append(headingCell); }
          thead.append(headerRow);
          const tbody = document.createElement('tbody');
          for (const { item, detail } of lines) {
            const row = document.createElement('tr');
            row.className = 'my-jobs-page__details-product-row';
            row.draggable = true;
            row.dataset.productLineId = item.lineId;
            row.setAttribute('aria-label', 'Drag ' + detail.title + ' to another asset');
            row.addEventListener('dragstart', (event) => {
              event.dataTransfer.effectAllowed = 'move';
              event.dataTransfer.setData('application/x-das-product', String(item.lineId));
              row.classList.add('is-dragging');
            });
            row.addEventListener('dragend', () => row.classList.remove('is-dragging'));
            const productCell = document.createElement('td');
            const product = document.createElement('div');
            product.className = 'my-jobs-page__details-product';
            if (detail.image) {
              const image = document.createElement('img');
              image.src = detail.image;
              image.alt = '';
              image.loading = 'lazy';
              product.append(image);
            }
            const title = document.createElement('span');
            if (item.productUrl) {
              const link = document.createElement('a');
              link.href = item.productUrl;
              link.textContent = detail.title;
              title.append(link);
            } else title.textContent = detail.title;
            if (detail.variantTitle && detail.variantTitle !== 'Default Title') title.append(text('small', detail.variantTitle, 'my-jobs-page__variant'));
            if (detail.datasheet) {
              const datasheet = text('a', 'Download datasheet', 'my-jobs-page__datasheet');
              datasheet.href = detail.datasheet;
              datasheet.target = '_blank';
              datasheet.rel = 'noopener noreferrer';
              title.append(datasheet);
            } else title.append(text('small', 'Datasheet not available', 'my-jobs-page__datasheet-missing'));
            product.append(title);
            productCell.append(product);
            productCell.setAttribute('data-label', 'Product');
            const skuCell = text('td', detail.sku);
            skuCell.setAttribute('data-label', 'SKU');
            const quantityCell = text('td', String(Number(item.quantity) || 1));
            quantityCell.setAttribute('data-label', 'Qty');
            const unitPriceCell = text('td', detail.unitPrice === null ? 'Unavailable' : formatMoney(root, detail.unitPrice));
            unitPriceCell.setAttribute('data-label', 'Unit price ex VAT');
            const subtotalCell = text('td', detail.unitPrice === null ? 'Unavailable' : formatMoney(root, detail.unitPrice * (Number(item.quantity) || 1)));
            subtotalCell.setAttribute('data-label', 'Subtotal ex VAT');
            row.append(productCell, skuCell, quantityCell, unitPriceCell, subtotalCell);
            tbody.append(row);
          }
          table.append(colgroup, thead, tbody);
          tableWrap.append(table);
          typeGroup.append(tableWrap);
          group.append(typeGroup);
        }
        if (doorGroup.id) group.append(doorNotesEditor(root, job, doorGroup));
        content.append(group);
      }
    };
    const button = (label, action, primary = false) => {
      const element = document.createElement('button');
      element.type = 'button';
      element.className = primary ? 'my-jobs-page__button my-jobs-page__button--primary' : 'my-jobs-page__button';
      element.textContent = label;
      element.dataset.jobAction = action;
      return element;
    };
    const text = (tag, value, className) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      element.textContent = value;
      return element;
    };
    const renderProjectMap = (root, jobs) => {
      const canvas = root.querySelector('[data-project-map-canvas]');
      const pinLayer = canvas?.querySelector('[data-project-map-pins]');
      const count = root.querySelector('[data-project-map-count]');
      const empty = root.querySelector('[data-project-map-empty]');
      const selected = root.querySelector('[data-project-map-selected]');
      if (!canvas || !pinLayer || !count || !empty || !selected) return;
      const locations = jobs.filter((job) => (job.status === 'ordered' || job.status === 'completed') && job.sitePostcode && job.mapLocation);
      pinLayer.replaceChildren();
      count.textContent = locations.length + ' project' + (locations.length === 1 ? '' : 's');
      empty.hidden = locations.length > 0;
      selected.hidden = true;
      if (!locations.length) return;
      for (const [index, job] of locations.entries()) {
        const longitude = Number(job.mapLocation.longitude);
        const latitude = Number(job.mapLocation.latitude);
        const x = 826.5 + (longitude * 96.5);
        const y = 10350 - (latitude * 167.5);
        if (!Number.isFinite(x) || !Number.isFinite(y) || x < 0 || x > 1022 || y < 400 || y > 2100) continue;
        const pin = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        pin.setAttribute('class', 'my-jobs-page__map-pin');
        pin.setAttribute('cx', x.toFixed(2));
        pin.setAttribute('cy', y.toFixed(2));
        pin.setAttribute('r', '15');
        pin.setAttribute('tabindex', '0');
        pin.setAttribute('role', 'button');
        pin.setAttribute('aria-label', job.name + ', ' + job.sitePostcode);
        pin.style.animationDelay = Math.min(index * 70, 700) + 'ms';
        const showProject = () => { selected.textContent = job.name + ' — ' + job.sitePostcode; selected.hidden = false; };
        pin.addEventListener('click', showProject);
        pin.addEventListener('keydown', (event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); showProject(); } });
        pin.append(document.createElementNS('http://www.w3.org/2000/svg', 'title'));
        pin.lastChild.textContent = job.name + ' — ' + job.sitePostcode;
        pinLayer.append(pin);
      }
    };
    const render = (root, jobs) => {
      root._savedJobs = jobs;
      renderProjectMap(root, jobs);
      for (const status of ['live', 'ordered', 'completed']) {
        const list = root.querySelector('[data-jobs-list="' + status + '"]');
        const empty = root.querySelector('[data-jobs-empty="' + status + '"]');
        list.replaceChildren();
        const searchText = (root.querySelector('[data-project-search]')?.value || '').trim().toLocaleLowerCase();
        const group = jobs.filter((job) => job.status === status && (!searchText || String(job.name || '').toLocaleLowerCase().includes(searchText)));
        if (searchText && !group.length) empty.textContent = 'No project titles match “' + root.querySelector('[data-project-search]').value.trim() + '”.';
        else if (empty.dataset.defaultText) empty.textContent = empty.dataset.defaultText;
        else empty.dataset.defaultText = empty.textContent;
        const groupCount = root.querySelector('[data-project-group-count="' + status + '"]');
        if (groupCount) groupCount.textContent = String(group.length);
        empty.hidden = group.length > 0;
        for (const job of group) {
          const card = document.createElement('article');
          card.className = 'my-jobs-page__card';
          card.dataset.jobId = job.id;
          const summary = document.createElement('div');
          summary.className = 'my-jobs-page__card-summary';
          const projectName = document.createElement('button');
          projectName.type = 'button';
          projectName.className = 'my-jobs-page__project-name';
          projectName.textContent = job.name;
          projectName.title = 'Click to rename this project';
          projectName.setAttribute('aria-label', 'Rename project ' + job.name);
          projectName.dataset.jobAction = 'edit-name';
          projectName.dataset.jobId = job.id;
          summary.append(projectName);
          summary.append(text('span', job.orderNumber || (status === 'ordered' ? 'Ordered' : status === 'completed' ? 'Completed' : 'Not ordered'), 'my-jobs-page__order-status'));
          if (job.reference) summary.append(text('span', job.reference));
          const toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'my-jobs-page__project-toggle';
          toggle.textContent = '+';
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Expand project ' + job.name);
          toggle.dataset.jobAction = 'toggle-project';
          toggle.dataset.jobId = job.id;
          summary.append(toggle);
          const cardContent = document.createElement('div');
          cardContent.className = 'my-jobs-page__card-content';
          cardContent.hidden = true;
          const doorGroups = [...(job.doors || []).map((door) => ({ id: door.id, name: door.name })), { id: '', name: 'Unassigned items' }];
          for (const door of doorGroups) {
            const assigned = (job.products || []).map((product, index) => ({ product, index })).filter(({ product }) => (product.doorId || '') === door.id);
            const doorDetails = document.createElement('details');
            doorDetails.className = 'my-jobs-page__door';
            const doorSummary = document.createElement('summary');
            doorSummary.className = 'my-jobs-page__door-summary';
            const doorChevron = text('span', '›', 'my-jobs-page__door-chevron');
            doorChevron.setAttribute('aria-hidden', 'true');
            const doorLabel = text('span', door.name, 'my-jobs-page__door-label');
            const doorCount = text('span', assigned.length ? assigned.length + ' product' + (assigned.length === 1 ? '' : 's') : 'No products', 'my-jobs-page__door-count');
            doorSummary.append(doorChevron, doorLabel, doorCount);
            doorDetails.append(doorSummary);
            const products = document.createElement('ul');
            products.className = 'my-jobs-page__products';
          for (const { product, index: productIndex } of assigned) {
            const row = document.createElement('li');
            row.className = 'my-jobs-page__product';
            const info = document.createElement('div');
            info.className = 'my-jobs-page__product-info';
            const name = product.title || 'Saved product';
            if (product.productUrl) {
              const link = document.createElement('a');
              link.href = product.productUrl;
              link.textContent = name;
              info.append(link);
            } else info.append(text('span', name));
            const controls = document.createElement('div');
            controls.className = 'my-jobs-page__product-controls';
            const quantity = document.createElement('input');
            quantity.className = 'my-jobs-page__quantity';
            quantity.type = 'number';
            quantity.min = '1';
            quantity.step = '1';
            quantity.value = String(Math.max(1, Number(product.quantity) || 1));
            quantity.setAttribute('aria-label', 'Quantity for ' + name);
            quantity.addEventListener('change', async () => {
              const nextQuantity = Number(quantity.value);
              const currentQuantity = Number(job.products[productIndex]?.quantity) || 1;
              if (!Number.isInteger(nextQuantity) || nextQuantity < 1) {
                quantity.value = String(currentQuantity);
                return;
              }
              const updatedProducts = [...(job.products || [])];
              updatedProducts[productIndex] = { ...updatedProducts[productIndex], quantity: nextQuantity };
              job.products = updatedProducts;
              const message = root.querySelector('[data-jobs-message]');
              updateSubtotal(root, job, subtotal);
              try {
                await saveJobProducts(root, job, updatedProducts);
                message.hidden = true;
              } catch (error) {
                message.textContent = error.message || root.dataset.messageError;
                message.hidden = false;
              }
            });
            const removeProduct = document.createElement('button');
            removeProduct.type = 'button';
            removeProduct.className = 'my-jobs-page__remove-product';
            removeProduct.textContent = 'Remove';
            removeProduct.setAttribute('aria-label', 'Remove ' + name + ' from this project');
            removeProduct.addEventListener('click', async () => {
              removeProduct.disabled = true;
              const updatedProducts = (job.products || []).filter((_, index) => index !== productIndex);
              const message = root.querySelector('[data-jobs-message]');
              try {
                await saveJobProducts(root, job, updatedProducts);
                job.products = updatedProducts;
                await load(root);
                message.hidden = true;
              } catch (error) {
                message.textContent = error.message || root.dataset.messageError;
                message.hidden = false;
                removeProduct.disabled = false;
              }
            });
            controls.append(quantity, removeProduct);
            row.append(info, controls);
            products.append(row);
          }
            if (!assigned.length) products.append(text('li', 'No products assigned to an asset yet.'));
            doorDetails.append(products);
            cardContent.append(doorDetails);
          }
          if (!job.products?.length) cardContent.append(text('p', root.dataset.messageEmptyProducts));
          const doorForm = document.createElement('form');
          doorForm.className = 'my-jobs-page__add-door';
          const doorLocation = document.createElement('select');
          doorLocation.className = 'my-jobs-page__door-location';
          doorLocation.name = 'location';
          doorLocation.setAttribute('aria-label', 'Asset location');
          const locations = doorLocationOptions;
          for (const location of locations) {
            const option = document.createElement('option');
            option.value = location;
            option.textContent = location;
            doorLocation.append(option);
          }
          const otherLocation = document.createElement('input');
          otherLocation.className = 'my-jobs-page__other-location';
          otherLocation.type = 'text';
          otherLocation.maxLength = 120;
          otherLocation.placeholder = 'Enter asset location';
          otherLocation.setAttribute('aria-label', 'Other asset location');
          const addDoor = document.createElement('button');
          addDoor.type = 'submit'; addDoor.className = 'my-jobs-page__button'; addDoor.textContent = 'Add asset';
          const updateOtherVisibility = () => {
            const isOther = doorLocation.value === 'Other';
            otherLocation.classList.toggle('is-visible', isOther);
            otherLocation.required = isOther;
          };
          doorLocation.addEventListener('change', updateOtherVisibility);
          doorForm.append(doorLocation, otherLocation, addDoor);
          doorForm.addEventListener('submit', async (event) => {
            event.preventDefault();
            addDoor.disabled = true;
            try {
              const name = doorLocation.value === 'Other' ? otherLocation.value.trim() : doorLocation.value;
              if (!name) throw new Error('Enter the asset location.');
              const door = { id: crypto.randomUUID(), name };
              await request(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ doors: [...(job.doors || []), door] }) });
              await load(root);
            } catch (error) { message.textContent = error.message || root.dataset.messageError; message.hidden = false; addDoor.disabled = false; }
          });
          cardContent.append(doorForm);
          const subtotal = text('p', 'Subtotal ex VAT: loading…', 'my-jobs-page__subtotal');
          cardContent.append(subtotal);
          updateSubtotal(root, job, subtotal);
          const actions = document.createElement('div');
          actions.className = 'my-jobs-page__actions';
          const order = button(job.status === 'ordered' || job.status === 'completed' ? 'Reorder' : root.dataset.messageOrder, 'order', true);
          order.classList.add('my-jobs-page__button--order');
          order.dataset.jobId = job.id;
          actions.append(order);
          const quote = button(job.quote?.status === 'sent' ? 'Raise revised quote' : 'Raise quote', 'quote', true);
          quote.classList.add('my-jobs-page__button--quote', 'my-jobs-page__button--order');
          quote.dataset.jobId = job.id;
          quote.disabled = !(job.products || []).length;
          const quoteAction = document.createElement('div');
          quoteAction.className = 'my-jobs-page__quote-action';
          quoteAction.append(quote);
          const cardQuoteMeta = quoteMeta(root, job);
          if (cardQuoteMeta) quoteAction.append(cardQuoteMeta);
          actions.append(quoteAction);
          const details = button('Plan Project Details', 'details');
          details.dataset.jobId = job.id;
          actions.append(details);
          const print = button('Download engineers sheet (PDF)', 'print', job.status === 'ordered' || job.status === 'completed');
          print.classList.add('my-jobs-page__engineers-sheet-button');
          if (job.status !== 'ordered' && job.status !== 'completed') print.classList.add('my-jobs-page__engineers-sheet-button--locked');
          print.dataset.jobId = job.id;
          actions.append(print);
          const duplicate = button(root.dataset.messageDuplicate, 'duplicate');
          duplicate.dataset.jobId = job.id;
          actions.append(duplicate);
          if (status === 'ordered') {
            const complete = button(root.dataset.messageComplete, 'set-status');
            complete.dataset.jobId = job.id;
            complete.dataset.status = 'completed';
            actions.append(complete);
            const markLive = button(root.dataset.messageLive, 'set-status');
            markLive.dataset.jobId = job.id;
            markLive.dataset.status = 'live';
            actions.append(markLive);
          } else if (status === 'completed') {
            const markLive = button(root.dataset.messageLive, 'set-status');
            markLive.dataset.jobId = job.id;
            markLive.dataset.status = 'live';
            actions.append(markLive);
          }
          const remove = button('Delete project', 'delete');
          remove.dataset.jobId = job.id;
          actions.append(remove);
          cardContent.append(actions);
          card.append(summary, cardContent);
          list.append(card);
        }
      }
    };
    const load = async (root) => {
      const data = await request(root.dataset.apiRoot);
      render(root, data.jobs || []);
    };
      for (const root of scope.querySelectorAll('[data-saved-jobs-page]')) {
        if (root.dataset.jobsInitialized) continue;
        root.dataset.jobsInitialized = 'true';
        const message = root.querySelector('[data-jobs-message]');
        const detailsDialog = root.querySelector('[data-project-details-dialog]');
        if (!detailsDialog) continue;
        root.querySelector('[data-close-project-details]').addEventListener('click', () => detailsDialog.close());
        root.querySelector('[data-project-search]').addEventListener('input', () => render(root, root._savedJobs || []));
        detailsDialog.addEventListener('click', (event) => { if (event.target === detailsDialog) detailsDialog.close(); });
        message.textContent = root.dataset.messageLoading;
        message.hidden = false;
        load(root).then(() => { message.hidden = true; }).catch((error) => {
          message.textContent = error.message || root.dataset.messageError;
          message.hidden = false;
        });
        root.addEventListener('click', async (event) => {
          const control = event.target.closest('[data-job-action]');
          if (!control) return;
          const { jobId, jobAction, status } = control.dataset;
          if (jobAction === 'toggle-project') {
            event.preventDefault();
            const cardContent = control.closest('.my-jobs-page__card')?.querySelector('.my-jobs-page__card-content');
            if (!cardContent) return;
            cardContent.hidden = !cardContent.hidden;
            control.textContent = cardContent.hidden ? '+' : '−';
            control.setAttribute('aria-expanded', String(!cardContent.hidden));
            control.setAttribute('aria-label', (cardContent.hidden ? 'Expand project ' : 'Collapse project ') + ((root._savedJobs || []).find((entry) => String(entry.id) === String(jobId))?.name || ''));
            return;
          }
          if (jobAction === 'edit-name') {
            event.preventDefault();
            const job = (root._savedJobs || []).find((entry) => String(entry.id) === String(jobId));
            if (!job) return;
            const input = document.createElement('input');
            input.type = 'text';
            input.className = 'my-jobs-page__project-name-input';
            input.maxLength = 120;
            input.value = job.name;
            input.setAttribute('aria-label', 'Edit project name');
            const originalName = job.name;
            let finished = false;
            const finishEdit = async (save) => {
              if (finished) return;
              if (!save) { finished = true; input.replaceWith(control); return; }
              const nextName = input.value.trim();
              if (!nextName) { message.textContent = 'Enter a project name.'; message.hidden = false; input.focus(); return; }
              if (nextName === originalName) { finished = true; input.replaceWith(control); return; }
              input.disabled = true;
              try {
                const result = await request(root.dataset.apiRoot + '/' + encodeURIComponent(jobId), { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name: nextName }) });
                const confirmed = result.job?.name;
                const latest = await request(root.dataset.apiRoot + '/' + encodeURIComponent(jobId));
                const persisted = latest.job?.name || confirmed;
                if (persisted !== nextName) throw new Error('The project name was not saved. Please try again.');
                finished = true;
                await load(root);
                message.hidden = true;
              } catch (error) {
                message.textContent = error.message || root.dataset.messageError;
                message.hidden = false;
                input.disabled = false;
                input.focus();
                input.select();
              }
            };
            input.addEventListener('click', (editEvent) => editEvent.stopPropagation());
            input.addEventListener('keydown', (editEvent) => {
              editEvent.stopPropagation();
              if (editEvent.key === 'Enter') { editEvent.preventDefault(); finishEdit(true); }
              if (editEvent.key === 'Escape') { editEvent.preventDefault(); finishEdit(false); }
            });
            input.addEventListener('blur', () => finishEdit(true));
            control.replaceWith(input);
            input.focus();
            input.select();
            return;
          }
          if (jobAction === 'print') {
            const job = (root._savedJobs || []).find((entry) => String(entry.id) === String(jobId));
            if (!job || (job.status !== 'ordered' && job.status !== 'completed')) {
              window.alert('An order needs to be placed before you can download the engineers project sheet.');
              return;
            }
            control.disabled = true;
            try { await printProject(root, jobId); message.hidden = true; }
            catch (error) { message.textContent = error.message || root.dataset.messageError; message.hidden = false; }
            finally { control.disabled = false; }
            return;
          }
          if (jobAction === 'quote') {
            const job = (root._savedJobs || []).find((entry) => String(entry.id) === String(jobId));
            if (!job) return;
            const isRevision = job.quote?.status === 'sent';
            const confirmation = isRevision
              ? 'Create and email a new revised quote using the project’s current products?'
              : 'Raise the current project items as a quote to the email address on your account?';
            if (!window.confirm(confirmation)) return;
            control.disabled = true;
            const originalLabel = control.textContent;
            control.textContent = 'Raising quote…';
            try {
              const result = await request(root.dataset.apiRoot + '/' + encodeURIComponent(jobId) + '/quote', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ revision: isRevision })
              });
              const quoteName = result.quote?.draftOrderName || 'Quote';
              control.textContent = 'Raise revised quote';
              control.disabled = false;
              await load(root);
              message.textContent = result.quote?.alreadySent
                ? quoteName + ' has already been sent for this version of the project.'
                : quoteName + ' has been created and emailed to you.';
              message.hidden = false;
            } catch (error) {
              control.textContent = originalLabel;
              control.disabled = false;
              message.textContent = error.message || root.dataset.messageError;
              message.hidden = false;
            }
            return;
          }
          if (jobAction === 'duplicate-door') {
            const job = (root._savedJobs || []).find((entry) => String(entry.id) === String(jobId));
            const sourceDoor = (job?.doors || []).find((door) => String(door.id) === String(control.dataset.doorId));
            if (!job || !sourceDoor) return;
            control.disabled = true;
            try {
              const copiedDoorId = 'door-' + crypto.randomUUID();
              const copiedDoor = { ...sourceDoor, id: copiedDoorId, name: (sourceDoor.name + ' (copy)').slice(0, 120) };
              const copiedProducts = (job.products || [])
                .filter((product) => String(product.doorId) === String(sourceDoor.id))
                .map((product) => ({ ...product, lineId: crypto.randomUUID(), doorId: copiedDoorId }));
              const result = await request(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ doors: [...(job.doors || []), copiedDoor], products: [...(job.products || []), ...copiedProducts] })
              });
              detailsDialog.close();
              await openProjectDetails(root, result.job);
              message.hidden = true;
            } catch (error) {
              message.textContent = error.message || root.dataset.messageError;
              message.hidden = false;
            } finally { control.disabled = false; }
            return;
          }
          if (jobAction === 'remove-door') {
            const job = (root._savedJobs || []).find((entry) => String(entry.id) === String(jobId));
            const sourceDoor = (job?.doors || []).find((door) => String(door.id) === String(control.dataset.doorId));
            if (!job || !sourceDoor) return;
            const assignedCount = (job.products || []).filter((product) => String(product.doorId) === String(sourceDoor.id)).length;
            const confirmation = assignedCount
              ? 'Remove ' + sourceDoor.name + '? Its ' + assignedCount + ' assigned product' + (assignedCount === 1 ? '' : 's') + ' will move to Unassigned items.'
              : 'Remove ' + sourceDoor.name + '?';
            if (!window.confirm(confirmation)) return;
            control.disabled = true;
            try {
              const result = await request(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  doors: (job.doors || []).filter((door) => String(door.id) !== String(sourceDoor.id)),
                  products: (job.products || []).map((product) => String(product.doorId) === String(sourceDoor.id) ? { ...product, doorId: undefined } : product)
                })
              });
              detailsDialog.close();
              await openProjectDetails(root, result.job);
              message.hidden = true;
            } catch (error) {
              message.textContent = error.message || root.dataset.messageError;
              message.hidden = false;
            } finally { control.disabled = false; }
            return;
          }
          if (jobAction === 'details') {
            const job = (root._savedJobs || []).find((entry) => String(entry.id) === String(jobId));
            if (!job) return;
            control.disabled = true;
            try { await openProjectDetails(root, job); }
            catch (error) {
              message.textContent = error.message || root.dataset.messageError;
              message.hidden = false;
            } finally { control.disabled = false; }
            return;
          }
          control.disabled = true;
          try {
            if (jobAction === 'delete') {
              if (!window.confirm(root.dataset.messageDelete)) return;
              await request(root.dataset.apiRoot + '/' + encodeURIComponent(jobId), { method: 'DELETE' });
            } else if (jobAction === 'duplicate') {
              await request(root.dataset.apiRoot + '/' + encodeURIComponent(jobId) + '/duplicate', { method: 'POST' });
            } else if (jobAction === 'set-status') {
              let project = (root._savedJobs || []).find((entry) => String(entry.id) === String(jobId));
              if (!project) throw new Error('Project not found. Refresh and try again.');
              await request(root.dataset.apiRoot + '/' + encodeURIComponent(jobId), { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status }) });
            } else if (jobAction === 'order') {
              let { job } = await request(root.dataset.apiRoot + '/' + encodeURIComponent(jobId));
              job = await ensureMapLocation(root, job);
              const items = (job.products || []).map((product) => ({ id: String(product.variantId).split('/').pop(), quantity: product.quantity, properties: { 'DAS Project ID': String(job.id), ...(product.builderSource === 'access-control' ? { '_DAS Builder': 'access-control', Position: product.builderPosition || '' } : {}) } }));
              if (!items.length) throw new Error(root.dataset.messageEmptyProducts);
              const cartResponse = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
              if (!cartResponse.ok) throw new Error(root.dataset.messageCartError);
              window.location.assign(root.dataset.cartUrl);
              return;
            }
            await load(root);
            message.textContent = '';
            message.hidden = true;
          } catch (error) {
            message.textContent = error.message || root.dataset.messageError;
            message.hidden = false;
          } finally {
            control.disabled = false;
          }
        });
      }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeSavedJobsPage());
  else initializeSavedJobsPage();
  document.addEventListener('shopify:section:load', (event) => initializeSavedJobsPage(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-saved-jobs"] && !Shopify.designMode) return;
  try {
    
    const initializeSavedJobsProduct = (scope = document) => {
      const jobsRequest = async (url, options = {}) => {
        const response = await fetch(url, { credentials: 'same-origin', ...options });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data?.error?.message || 'The request could not be completed.');
        return data;
      };
      const currentProduct = (root) => {
        const form = document.querySelector('form[action*="/cart/add"]');
        const variant = form?.querySelector('[name="id"]')?.value || root.dataset.variantId;
        const quantity = Number(form?.querySelector('[name="quantity"]')?.value || 1);
        return {
          productId: root.dataset.productId,
          variantId: variant,
          quantity: Number.isInteger(quantity) && quantity > 0 ? quantity : 1,
          title: root.dataset.productTitle,
          productUrl: root.dataset.productUrl
        };
      };
      const showMessage = (panel, message) => {
        const output = panel.querySelector('[data-product-saved-jobs-message]');
        output.textContent = message;
        output.hidden = !message;
      };
      const showProjectConfirmation = (panel, job, addedDoor) => {
        panel.querySelector('[data-product-saved-jobs-message]').hidden = true;
        panel.querySelector('[data-live-jobs-list]').hidden = true;
        panel.querySelector('[data-live-jobs-empty]').hidden = true;
        panel.querySelector('[data-door-picker]').hidden = true;
        panel.querySelector('[data-create-job-form]').hidden = true;
        const confirmation = panel.querySelector('[data-project-confirmation]');
        const door = addedDoor || (job.doors || []).find((entry) => entry.id === job.products?.at(-1)?.doorId);
        confirmation.querySelector('[data-project-confirmation-title]').textContent = 'Added to ' + job.name + (door ? ' · ' + door.name : '');
        const productList = confirmation.querySelector('[data-project-confirmation-products]');
        productList.replaceChildren();
        for (const product of job.products || []) {
          const row = document.createElement('li');
          row.textContent = (product.title || 'Saved product') + ' × ' + (product.quantity || 1);
          productList.append(row);
        }
        confirmation.hidden = false;
        panel.classList.add('product-saved-jobs__dialog--confirmation');
      };
      const resetProjectConfirmation = (panel) => {
        panel.querySelector('[data-live-jobs-list]').hidden = false;
        panel.querySelector('[data-door-picker]').hidden = true;
        panel.querySelector('[data-create-job-form]').hidden = false;
        panel.querySelector('[data-project-confirmation]').hidden = true;
        panel.classList.remove('product-saved-jobs__dialog--confirmation');
      };
      const addProductToProject = async (root, panel, job, door) => {
        const item = currentProduct(root);
        if (door) item.doorId = door.id;
        const products = [...(job.products || [])];
        const existing = products.find((saved) => String(saved.variantId).split('/').pop() === String(item.variantId).split('/').pop() && String(saved.doorId || '') === String(item.doorId || ''));
        if (existing) {
          existing.quantity += item.quantity;
        } else products.push(item);
        await jobsRequest(root.dataset.apiRoot + '/' + encodeURIComponent(job.id), { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ products }) });
        const updated = await jobsRequest(root.dataset.apiRoot + '/' + encodeURIComponent(job.id));
        showProjectConfirmation(panel, updated.job || { ...job, products }, door);
      };
      const showDoorPicker = (root, panel, job) => {
        panel._selectedProject = job;
        panel.querySelector('[data-live-jobs-list]').hidden = true;
        panel.querySelector('[data-live-jobs-empty]').hidden = true;
        panel.querySelector('[data-create-job-form]').hidden = true;
        const picker = panel.querySelector('[data-door-picker]');
        const list = picker.querySelector('[data-door-choices]');
        picker.querySelector('[data-door-project-title]').textContent = job.name;
        list.replaceChildren();
        for (const door of job.doors || []) {
          const choice = document.createElement('button');
          choice.type = 'button';
          choice.className = 'product-saved-jobs__choice';
          choice.textContent = door.name;
          choice.addEventListener('click', async () => {
            choice.disabled = true;
            try { await addProductToProject(root, panel, job, door); }
            catch (error) { showMessage(panel, error.message || root.dataset.messageError); choice.disabled = false; }
          });
          list.append(choice);
        }
        const unassigned = document.createElement('button');
        unassigned.type = 'button';
        unassigned.className = 'product-saved-jobs__choice';
        unassigned.textContent = 'Unassigned items';
        unassigned.addEventListener('click', async () => {
          unassigned.disabled = true;
          try { await addProductToProject(root, panel, job, null); }
          catch (error) { showMessage(panel, error.message || root.dataset.messageError); unassigned.disabled = false; }
        });
        list.append(unassigned);
        picker.hidden = false;
      };
      const refreshJobs = async (root, panel) => {
        const { jobs } = await jobsRequest(root.dataset.apiRoot);
        const list = panel.querySelector('[data-live-jobs-list]');
        const liveJobs = (jobs || []).filter((job) => job.status === 'live');
        list.replaceChildren();
        panel.querySelector('[data-live-jobs-empty]').hidden = liveJobs.length > 0;
        for (const job of liveJobs) {
          const choice = document.createElement('button');
          choice.type = 'button';
          choice.className = 'product-saved-jobs__choice';
          choice.textContent = job.name;
          choice.addEventListener('click', async () => {
            showDoorPicker(root, panel, job);
          });
          list.append(choice);
        }
      };
        for (const root of scope.querySelectorAll('[data-saved-jobs-product]')) {
          if (root.dataset.jobsInitialized) continue;
          root.dataset.jobsInitialized = 'true';
          const dialog = root.querySelector('dialog');
          const trigger = root.querySelector('[data-open-saved-jobs]');
          const addToCart = document.querySelector('.buy-buttons-block product-form-component add-to-cart-component');
          const section = root.closest('.shopify-section');
          document.body.append(dialog);
          if (addToCart) addToCart.insertAdjacentElement('afterend', trigger);
          if (section) section.hidden = true;
          trigger.addEventListener('click', async () => {
            resetProjectConfirmation(dialog);
            showMessage(dialog, root.dataset.messageLoading);
            dialog.showModal();
            try { await refreshJobs(root, dialog); showMessage(dialog, ''); }
            catch (error) { showMessage(dialog, error.message || root.dataset.messageError); }
          });
          dialog.querySelector('[data-close-saved-jobs]').addEventListener('click', () => { resetProjectConfirmation(dialog); dialog.close(); });
          dialog.querySelector('[data-project-confirmation-close]').addEventListener('click', () => { resetProjectConfirmation(dialog); dialog.close(); });
          dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
          dialog.querySelector('[data-create-job-form]').addEventListener('submit', async (event) => {
            event.preventDefault();
            const form = event.currentTarget;
            const submit = form.querySelector('[type="submit"]');
            submit.disabled = true;
            try {
              const item = currentProduct(root);
              const projectName = String(new FormData(form).get('name') || '').trim();
              const doorName = String(new FormData(form).get('doorName') || '').trim();
              const doors = doorName ? [{ id: crypto.randomUUID(), name: doorName }] : [];
              if (doors.length) item.doorId = doors[0].id;
              const created = await jobsRequest(root.dataset.apiRoot, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name: projectName, doors, products: [item] }) });
              form.reset();
              const project = created.job || (await jobsRequest(root.dataset.apiRoot)).jobs?.find((entry) => entry.name === projectName);
              if (!project) throw new Error(root.dataset.messageError);
              showProjectConfirmation(dialog, project, doors[0]);
            } catch (error) { showMessage(dialog, error.message || root.dataset.messageError); }
            finally { submit.disabled = false; }
          });
          dialog.querySelector('[data-create-door-form]').addEventListener('submit', async (event) => {
            event.preventDefault();
            const form = event.currentTarget;
            const submit = form.querySelector('[type="submit"]');
            submit.disabled = true;
            try {
              const selected = dialog._selectedProject;
              const name = String(new FormData(form).get('name') || '').trim();
              if (!selected || !name) return;
              const door = { id: crypto.randomUUID(), name };
              const item = { ...currentProduct(root), doorId: door.id };
              const products = [...(selected.products || [])];
              // Newly created doors always have independent product lines.
              products.push(item);
              await jobsRequest(root.dataset.apiRoot + '/' + encodeURIComponent(selected.id), { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ doors: [...(selected.doors || []), door], products }) });
              const updated = await jobsRequest(root.dataset.apiRoot + '/' + encodeURIComponent(selected.id));
              form.reset();
              showProjectConfirmation(dialog, updated.job || { ...selected, doors: [...(selected.doors || []), door], products }, door);
            } catch (error) { showMessage(dialog, error.message || root.dataset.messageError); }
            finally { submit.disabled = false; }
          });
          dialog.querySelector('[data-door-back]').addEventListener('click', () => {
            dialog.querySelector('[data-door-picker]').hidden = true;
            dialog.querySelector('[data-live-jobs-list]').hidden = false;
            dialog.querySelector('[data-create-job-form]').hidden = false;
          });
        }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeSavedJobsProduct());
    else initializeSavedJobsProduct();
    document.addEventListener('shopify:section:load', (event) => initializeSavedJobsProduct(event.target));
  
  } catch(e) { console.error(e); }
})();
})();
